module.exports = new __parcel__URL__("jpd-portfolio-management-capacity-planning-dark.2f63f151.svg").toString();